<template>
  <v-hover v-slot="{ hover }">
    <v-card
      :color="selected ? 'primary lighten-3' : null"
      class="ma-2 px-2 py-1"
      :style="{cursor: 'pointer'}"
      @click="click"
    >
      <div>
        <div
          v-if="$vuetify.breakpoint.smAndDown"
          class="text-truncate"
          :style="{display: 'grid', 'grid-template-columns': '1fr auto'}"
        >
          <div class="flex-column">
            <div class="text-truncate">
              Table: <span class="font-weight-bold">{{ table.name }}</span>
            </div>
            <v-divider style="margin: auto; border-color: grey; width: 95%;" />
            <div class="text-truncate">
              Covers: <span class="font-weight-bold">{{ table.maxCovers }}</span>
            </div>
          </div>
          <v-icon
            v-if="allowAdd"
            color="primary"
          >
            mdi-plus
          </v-icon>
          <v-icon
            v-else-if="allowRemove"
            color="black"
          >
            mdi-trash-can-outline
          </v-icon>
        </div>
        <v-row
          v-else
          no-gutters
        >
          <v-col
            cols="5"
            align-self="center"
            class="text-center"
            style="display: grid; grid-template-columns: 1fr auto;"
          >
            <div class="py-1 font-weight-bold">
              {{ table.name }}
            </div>
            <v-divider
              vertical
              class="black"
            />
          </v-col>
          <v-col
            cols="7"
            align-self="center"
            :style="{
              display: 'grid',
              'grid-template-columns': '1.5fr 1fr auto auto'
            }"
          >
            <div class="py-1 font-weight-bold d-flex justify-center align-self-center">
              {{ table.maxCovers }}
            </div>
            <div class="d-flex justify-center align-self-center">
              <div
                v-if="servers"
                class="d-flex"
              >
                <template v-for="(s, index) of displayServers">
                  <server-initial-icon
                    v-if="index < MAX_DISPLAYED_SERVERS"
                    :key="`server-icon-${table.id}-${s.id}`"
                    :server="s"
                  />
                </template>
                <div
                  v-if="(displayServers || []).length > MAX_DISPLAYED_SERVERS"
                  class="d-flex align-self-center pl-1"
                >
                  +
                </div>
              </div>
            </div>
            <div class="px-5 align-self-center">
              <slot name="adtl-content" />
            </div>
            <v-btn
              v-if="allowAdd"
              icon
              class="mx-1 align-self-center"
            >
              <v-icon color="primary">
                mdi-plus
              </v-icon>
            </v-btn>
            <v-btn
              v-if="allowRemove"
              icon
              class="mx-1 align-self-center"
            >
              <v-icon :color="selected ? 'black' : 'error'">
                mdi-trash-can-outline
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div
        v-if="location"
        class="font-weight-bold text-truncate"
        :class="{'text-right': $vuetify.breakpoint.smAndDown}"
      >
        {{ location }}
      </div>
    </v-card>
  </v-hover>
</template>

<script>
import ServerInitialIcon from '../helperComponents/ServerInitialIcon'
export default {
  name: 'TableCard',
  components: {ServerInitialIcon},
  props: {
    table: {
      type: Object,
      default () {return {}}
    },
    ripple: {
      type: Boolean,
      default: true
    },
    server: Object,
    servers: Array,
    location: String,
    allowAdd: Boolean,
    allowRemove: Boolean,
    selected: Boolean,
    noOverlay: Boolean,
  },
  data () {
    return {
      MAX_DISPLAYED_SERVERS: 3
    }
  },
  computed: {
    displayServers () {
      const {id: serverId} = this.server ?? {}
      return this.servers?.reduce((acc, s) => {
        if (s.id !== serverId) acc.push(s)
        return acc
      }, []) ?? []
    }
  },
  methods: {
    /**
     * Action called when clicking anywhere on this `TableCard`
     * Uses `TableCard`'s state to delegate emitted event
     */
    click () {
      const {allowAdd, allowRemove} = this
      if (allowAdd) this.$emit('click:add')
      else if (allowRemove) this.$emit('click:remove')
    }
  }
}
</script>

<style scoped>
.v-card::before {
  background: none;
}
</style>
